export namespace PermissionsConstants {
  export const ADDRESS_READ = 'address_read';
  export const AMENITY_READ = 'amenity_read';
  export const BANNER_MANAGEMENT = 'banner_management';
  export const CHAT_MESSAGE_READ = 'chat_message_read';
  export const CHAT_MESSAGE_CREATE = 'chat_message_create';
  export const CUSTOMER_SERVICE_NOTE_CREATE = 'customer_service_note_create';
  export const CUSTOMER_SERVICE_NOTE_READ = 'customer_service_note_read';
  export const DEACTIVATION_REASON_READ = 'deactivation_reason_read';
  export const DRIVER = 'driver';
  export const DRIVER_BANK_TRANSACTION_CREATE = 'driver_bank_transaction_create';
  export const DRIVER_BANK_TRANSACTION_REASON_READ = 'driver_bank_transaction_reason_read';
  export const DRIVER_MANAGEMENT = 'driver_management';
  export const DRIVER_ONBOARDING_MANAGEMENT = 'driver_onboarding_management';
  export const DRIVER_PROTECTED_READ = 'driver_protected_read';
  export const DRIVER_PROTECTED_RESERVATION_READ = 'driver_protected_reservation_read';
  export const DRIVER_SEARCH = 'driver_search';
  export const DRIVER_SUSPENSION_CREATE = 'driver_suspension_create';
  export const DRIVER_SUSPENSION_DELETE = 'driver_suspension_delete';
  export const DRIVER_SUSPENSION_READ = 'driver_suspension_read';
  export const DRIVER_SUSPENSION_UPDATE = 'driver_suspension_update';
  export const DRIVER_SUSPENSION_PERMANENT_CREATE = 'driver_suspension_permanent_create';
  export const DRIVER_SUSPENSION_PERMANENT_DELETE = 'driver_suspension_permanent_delete';
  export const DRIVER_TAX_INFORMATION_READ = 'driver_tax_information_read';
  export const DRIVER_TRAINING_MANGEMENT = 'driver_training_management';
  export const DOCUMENT_READ = 'document_read';
  export const FARE_REVIEW = 'fare_review';
  export const GEOFENCE_MANAGEMENT = 'geofence_management';
  export const INCENTIVE_READ = 'incentive_read';
  export const INCENTIVE_UPDATE = 'incentive_update';
  export const INSURANCE_MANAGEMENT = 'insurance_management';
  export const INSURANCE_READ = 'insurance_read';
  export const INTEGRATION_DISPATCH = 'integration_dispatch';
  export const ITINERARY_CREATE = 'itinerary_create';
  export const ITINERARY_READ = 'itinerary_read';
  export const ITINERARY_UPDATE = 'itinerary_update';
  export const ITINERARY_FILE_UPLOAD = 'itinerary_file_upload';
  export const ITINERARY_FILE_UPLOAD_READ_ALL = 'itinerary_file_upload_read_all';
  export const LOCATION_MANAGEMENT = 'location_management';
  export const LOCATION_READ = 'location_read';
  export const LOCATION_CREATE = 'location_create';
  export const LOCATION_SEARCH = 'location_search';
  export const LYFT_DISPATCH_MANAGEMENT = 'lyft_dispatch_management';
  export const MOBILITY_PROFILE_READ = 'mobility_profile_read';
  export const MOBILITY_PROFILE_WRITE = 'mobility_profile_write';
  export const ORGANIZATION_CREATE = 'organization_create';
  export const ORGANIZATION_READ = 'organization_read';
  export const ORGANIZATION_MANAGEMENT = 'organization_management';
  export const ORGANIZATION_RIDER_CREATE = 'organization_rider_create';
  export const ORGANIZATION_RIDER_READ = 'organization_rider_read';
  export const ORGANIZATION_RIDER_DELETE = 'organization_rider_delete';
  export const ORGANIZATION_RIDER_UPDATE = 'organization_rider_update';
  export const PROTECTED_ORGANIZTION_RIDER_PII = 'protected_organization_rider_pii';
  export const ORGANIZATION_SEARCH = 'organization_search';
  export const PAYOUTS_READ = 'payouts_read';
  export const PRODUCTION_SUPPORT = 'production_support';
  export const REPORT_READ = 'report_read';
  export const RESERVATION_READ = 'reservation_read';
  export const RESERVATION_SEARCH = 'reservation_search';
  export const RESERVATION_STATUS_UPDATE = 'reservation_status_update';
  export const RESERVATION_UPDATE = 'reservation_update';
  export const RIDE_CANCEL = 'ride_cancel';
  export const RIDE_MONITORING = 'ride_monitoring';
  export const RIDE_MONITORING_ALERT_READ = 'ride_monitoring_alert_read';
  export const RIDE_REQUEST_CREATE = 'ride_request_create';
  export const RIDE_REQUEST_READ = 'ride_request_read';
  export const RIDE_REQUEST_SEARCH = 'ride_request_search';
  export const RIDE_REQUEST_UPDATE = 'ride_request_update';
  export const RIDER_SUSPENSION_READ = 'rider_suspension_read';
  export const RIDER_SUSPENSION_CREATE = 'rider_suspension_create';
  export const RIDER_SUSPENSION_DELETE = 'rider_suspension_delete';
  export const RIDER_SUSPENSION_PERMANENT_CREATE = 'rider_suspension_permanent_create';
  export const RIDER_SUSPENSION_PERMANENT_DELETE = 'rider_suspension_permanent_delete';
  export const RIDE_TRACKING_READ = 'ride_tracking_read';
  export const RIDER = 'rider';
  export const RIDER_FARE_UPDATE = 'rider_fare_update';
  export const RIDER_MANAGEMENT = 'rider_management';
  export const RIDER_READ = 'rider_read';
  export const RIDER_SEARCH = 'rider_search';
  export const ROLE_MANAGEMENT = 'role_management';
  export const SUPPORT_MESSAGE_CREATE = 'support_message_create';
  export const SYSTEM = 'system';
  export const SYSTEM_CONFIGURATION = 'system_configuration';
  export const TRANSIT_PROGRAM_SEARCH = 'transit_program_search';
  export const USER_MANAGEMENT = 'user_management';
  export const USER_READ = 'user_read';
  export const USER_UPDATE = 'user_update';
  export const VEHICLE_CREATE = 'vehicle_create';
  export const VEHICLE_DELETE = 'vehicle_delete';
  export const VEHICLE_READ = 'vehicle_read';
  export const VEHICLE_UPDATE = 'vehicle_update';
  export const PROVIDER_READ = 'provider_read';
  export const PROVIDER_MANAGEMENT = 'provider_management';
  export const PROVIDER_OPERATOR_READ = 'provider_operator_read';
  export const PROVIDER_DRIVER_MANAGEMENT = 'provider_driver_management';
  export const PROVIDER_DISPATCHER_MANAGEMENT = 'provider_dispatcher_management';
  export const PROVIDER_RIDE_REQUEST_READ = 'provider_ride_request_read';
  export const PROVIDER_RIDE_REQUEST_UPDATE = 'provider_ride_request_update';
  export const RIDER_FARE_COLLECTION_OVERRIDE = 'rider_fare_collection_override';
  export const CLIENT_FEE_SCHEDULE_CREATE = 'client_fee_schedule_create';
  export const CLIENT_FEE_SCHEDULE_READ = 'client_fee_schedule_read';
  export const CLIENT_FEE_SCHEDULE_UPDATE = 'client_fee_schedule_update';
  export const PROVIDER_FEE_SCHEDULE_CREATE = 'provider_fee_schedule_create';
  export const PROVIDER_FEE_SCHEDULE_READ = 'provider_fee_schedule_read';
  export const PROVIDER_FEE_SCHEDULE_UPDATE = 'provider_fee_schedule_update';
  export const WEB_SELF_SERVICE_RIDE_CANCEL = 'web_self_service_ride_cancel';
  export const ORGANIZATION_RIDER_ELIGIBILITY_UPDATE = 'organization_rider_eligibility_update';
  export const ORGANIZATION_RIDER_ELIGIBILITY_FILE_UPLOAD = 'rider_eligibility_file_upload';
  export const RIDER_ELIGIBILITY_FILE_UPLOAD_READ_ALL = 'rider_eligibility_file_upload_read_all';
  export const SUBMIT_BACKDATED_FEE_SCHEDULE = 'submit_backdated_fee_schedule';
  export const CLIENT_FEE_ESTIMATE_READ = 'client_fee_estimate_read';
  export const ORGANIZATION_PAYMENT_ACCOUNT_READ = 'organization_payment_account_read';
  export const ORGANIZATION_PAYMENT_ACCOUNT_WRITE = 'organization_payment_account_write';
  export const ORGANIZATION_PAYMENT_ACCOUNT_DELETE = 'organization_payment_account_delete';
}
